(function ($) {
  $(function () {
    if ($('.truncate').length) {
      if ($('.truncate--2-lines').length) {
        var maxHeightTwoLines = 28 * 2;

        $('.truncate--2-lines').each(function () {
          $(this).dotdotdot({
            watch: true,
            height: maxHeightTwoLines,
            ellipsis: ' ... ',
            after: 'span.read-more',
            callback: dotdotdotCallback,
          });
        });

        $('.truncate--2-lines').on('click', 'span', function (e) {
          e.stopPropagation();
          if ($(this).text() == 'Show more') {
            var wrapperElement = $(this).closest('.truncate--2-lines');
            wrapperElement.trigger('destroy.dot').find('span.read-more').hide();
            wrapperElement.css('max-height', '');
            $('span.read-less', wrapperElement).show();
          } else {
            $('span.read-more', wrapperElement).show();

            $(this).closest('.truncate--2-lines').dotdotdot({
              watch: true,
              height: maxHeightTwoLines,
              ellipsis: ' ... ',
              after: 'span.read-more',
              callback: dotdotdotCallback,
            });
          }
        });
      }

      if ($('.truncate--3-lines').length) {
        var maxHeightThreeLines = 28 * 3;

        $('.truncate--3-lines').each(function () {
          $(this).dotdotdot({
            watch: true,
            height: maxHeightThreeLines,
            ellipsis: ' ... ',
            after: 'span.read-more',
            callback: dotdotdotCallback,
          });
        });

        $('.truncate--3-lines').on('click', 'span', function (e) {
          e.stopPropagation();
          if ($(this).text() == 'Show more') {
            var wrapperElement = $(this).closest('.truncate--3-lines');
            wrapperElement.trigger('destroy.dot').find('span.read-more').hide();
            wrapperElement.css('max-height', '');
            $('span.read-less', wrapperElement).show();
          } else {
            $('span.read-more', wrapperElement).show();

            $(this).closest('.truncate--3-lines').dotdotdot({
              watch: true,
              height: maxHeightThreeLines,
              ellipsis: ' ... ',
              after: 'span.read-more',
              callback: dotdotdotCallback,
            });
          }
        });
      }
    }

    function dotdotdotCallback(isTruncated, originalContent) {
      if (!isTruncated) {
        $('span', this).remove();
      }
    }
  });
})(jQuery);


(function ($) {
  $(function () {
    var $videosWithPlayer = $('.videos-with-player');

    if ($videosWithPlayer.length) {
      $window = $(window);

      var videosWithPlayer = (function () {
        var $video = $('.video-featured-card--horizontal');
        var $videoLink = $('.video-featured-card--horizontal a');
        var $videoPlayerIframeWrapper = $('.videos-with-player__player .iframe-wrapper');
        var $videoPlayerIframe = $('.videos-with-player__player iframe');

        function setVideoPlayerDimensions() {
          if ($videoPlayerIframe.length) {
            var videoBoxWidth = $videoPlayerIframeWrapper.width();
            var videoBoxHeight = (videoBoxWidth / 16) * 9;
  
            if ((videoBoxHeight + 100) > $window.height()) {
              videoBoxHeight = $videoPlayerIframeWrapper.height();
              videoBoxWidth = (videoBoxHeight / 9) * 16;
            }
  
            $videoPlayerIframe.css({
              width: videoBoxWidth + 'px',
              height: videoBoxHeight + 'px',
            });
          }
        }

        function getProperVideoLink(videoSrc) {
          var videoLink = $(videoSrc).attr('href');
          var videoId = '';
          var autoplay = '';

          if (videoLink.includes('vimeo') > 0) {
            videoId = videoLink.match(/vimeo\.com\/(\d+)/i)[1];

            console.log(videoId);

            return 'https://player.vimeo.com/video/' + videoId;
          } else {
            // If Youtube link is provided from Youtube URL,
            // then get the video id by slicing the 'https://www.youtube.com/watch?v='
            // from video URL
            if (videoLink.indexOf('watch') > 0) {
              videoId = videoLink.split('v=')[1];
            } 
  
            // If Youtube link is provided from Youtube Share button,
            // then get the video id by slicing the 'https://youtu.be/'
            // from share link
            else if (videoLink.indexOf('youtu.be') > 0) {
              videoId = videoLink.split('e/')[1];
            }
  
            // Remove any additional URL parameters, if any         
            if (videoId.indexOf('&') != -1) {
              videoId = videoId.substring(0, videoId.indexOf('&'));
            }
  
            // Autoplay video if autoplay 'allow="autoplay"' set on iframe
            if ($videoPlayerIframe.attr('allow') && $videoPlayerIframe.attr('allow') === 'autoplay') {
              autoplay = '?autoplay=1';
            }
            
            return '//www.youtube.com/embed/' + videoId + autoplay +'teets';
          }
        }

        function copyLink() {
          $videosWithPlayer.on('click', 'ul.social-icons li.tooltip a', function(e) {
            e.preventDefault();
            console.log('Tooltip called!');
            
            let copyText = document.getElementById("current-video-url");
            copyText.select();
            copyText.setSelectionRange(0, 99999);
            
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(copyText.value)
                .then(() => {
                  let tooltip = document.getElementById("urlTooltip");
                  tooltip.innerHTML = "URL Copied!";
                })
                .catch(err => {
                  console.error('Clipboard API failed: ', err);
                  fallbackCopy(copyText.value);
                });
            } else {
              fallbackCopy(copyText.value);
            }
          });

          $videosWithPlayer.on('mouseout', 'ul.social-icons li.tooltip a', function(e) {
            let tooltip = document.getElementById("urlTooltip");
            tooltip.innerHTML = "Copy to clipboard";
          });
        }
 
        function fallbackCopy(text) {
          var textArea = document.createElement("textarea");
          textArea.value = text;
          // Avoid scrolling to bottom
          textArea.style.position = "fixed";
          textArea.style.top = "0";
          textArea.style.left = "0";
          textArea.style.width = "2em";
          textArea.style.height = "2em";
          textArea.style.padding = "0";
          textArea.style.border = "none";
          textArea.style.outline = "none";
          textArea.style.boxShadow = "none";
          textArea.style.background = "transparent";
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
        
          try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'URL Copied!' : 'Copy to clipboard';
            var tooltip = document.getElementById("urlTooltip");
            tooltip.innerHTML = msg;
          } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
            var tooltip = document.getElementById("urlTooltip");
            tooltip.innerHTML = 'Copy to clipboard';
          }
        
          document.body.removeChild(textArea);
        }

        return {
          init: function () {
            setVideoPlayerDimensions();
            copyLink();
          },
          setVideoPlayerDimensions: setVideoPlayerDimensions,
          // playFirstVideo: playFirstVideo
        }
      })();

      videosWithPlayer.init();

      $(window).on('load', function () {
        videosWithPlayer.setVideoPlayerDimensions();
      });

      $window.on('resize orientationchange', videosWithPlayer.setVideoPlayerDimensions);
    }
  });
})(jQuery);
